// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

// export const environment: any = {
//     name: 'local',
//     production: false,
//     apiEndpoint: "https://api.shotpro.tv:3000",
//     // apiEndpoint: "https://addulate-api.yatilabs.com:3000",
//     androidApiEndpoint: 'http://10.0.2.2:3000',
//     iotEndpoints: {
//         // 'Asia/Tokyo': 'a1yg5dc4qcx5ex.iot.ap-northeast-1.amazonaws.com',
//         'default': 'a1yg5dc4qcx5ex-ats.iot.us-west-2.amazonaws.com',
//     },
//     // screenUrl: "https://addulate-screen-js.yatilabs.com/",
//     // screenUrl: "http://localhost:4100/",
//     screenUrl: "https://server.shotpro.tv/",
//     androidScreenUrl: "localhost:4100",
//     handshakeEndpoint: 'https://api2.addulate.com/v2',
//     cognitoRegion: 'us-west-2',
//     cognitoUserPoolId: 'us-west-1_DVKJU5IcP',
//     cognitoAppClientId: "5911q4gac4qk7p6nq6lcn792ah",
//     cognitoDeusModusIdentityPoolId: 'us-west-2:29f7ae83-a6d7-4d34-bebe-b132c6fdc123',
//     s3BucketName: "aduulate",
//     s3IdentityPoolId: "us-west-1:d78db170-6715-47a8-a67e-9f0c833b4f36",
//     mixpanel_token: '123abc-prod',
//     releaseInfo: "VersionInfo",
//     s3BucketRegion: 'us-west-1',
//     googleKey: 'AIzaSyDqHpprl75YRoQPmQ0c6GYPYf2fuFfXg3k', // TestProject for garyaddulate@gmail.com
// };


// New AWS Cognito and S3 Bucket settings pickcaster 
export const environment: any = {
    name: 'local',
    production: false,
    apiEndpoint: 'https://api.pickcaster.io:3000',
    androidApiEndpoint: 'http://10.0.2.2:3000',
    iotEndpoints: {
        'default': 'a1yg5dc4qcx5ex-ats.iot.us-west-2.amazonaws.com',
    },
    screenUrl: "https://server.pickcaster.io",
    // screenUrl: "http://localhost:4100",
    androidScreenUrl: "localhost:4100",
    handshakeEndpoint: 'https://api2.addulate.com/v2',
    cognitoRegion: 'us-west-2',
    cognitoUserPoolId: 'us-east-2_5q2GVsn0q',
    cognitoAppClientId: "4bnk5edf59sqc6lnrl65qvg1t7",
    cognitoDeusModusIdentityPoolId: 'us-west-2:29f7ae83-a6d7-4d34-bebe-b132c6fdc123',
    s3BucketName: "pickcaster",
    s3BucketRegion: 'us-east-2',
    s3IdentityPoolId: "us-east-2:bfb764d8-aa7f-4bd1-a848-6f4953a4cd14",
    mixpanel_token: '123abc-prod',
    releaseInfo: "VersionInfo",
    googleKey: 'AIzaSyDqHpprl75YRoQPmQ0c6GYPYf2fuFfXg3k',
};


// New AWS Cognito and S3 Bucket settings ShotCaster
// export const environment: any = {
//     name: 'local',
//     production: false,
//     apiEndpoint: "https://api.shotpro.tv:3000",
//     androidApiEndpoint: 'http://10.0.2.2:3000',
//     iotEndpoints: {
//         'default': 'a1yg5dc4qcx5ex-ats.iot.us-west-2.amazonaws.com',
//     },
//     screenUrl: "https://server.shotpro.tv/",
//     androidScreenUrl: "localhost:4100",
//     handshakeEndpoint: 'https://api2.addulate.com/v2',
//     cognitoRegion: 'us-west-2',
//     cognitoUserPoolId: 'us-east-2_APIf2DQzV',
//     cognitoAppClientId: "7nsqklgh9re3lm3n8cqcn21atq",
//     cognitoDeusModusIdentityPoolId: 'us-west-2:29f7ae83-a6d7-4d34-bebe-b132c6fdc123',
//     s3BucketName: "shotcaster",
//     s3BucketRegion: 'us-east-2',
//     s3IdentityPoolId: "us-east-2:3de64b20-ef7c-4ecb-ab50-ad11bad9ec16",
//     mixpanel_token: '123abc-prod',
//     releaseInfo: "VersionInfo",
//     googleKey: 'AIzaSyDqHpprl75YRoQPmQ0c6GYPYf2fuFfXg3k', // TestProject for garyaddulate@gmail.com
// };











// export const environment = {
//     production: false,
//     apiEndpoint: "http://52.52.124.106:3000",
//     screenUr: "http://52.52.124.106:4300",
//     androidScreenUrl: "http://52.52.124.106:4300",
//     cognitoAppClientId: "arn:aws:cognito-idp:us-west-1:684460736423:userpool/us-west",
//     s3BucketName: "addulate",
//     s3IdentityPoolId: "us-west-1:d78db170-6715-47a8-a67e-9f0c833b4f36",
//     mixpanel_token: '123abc-prod',
//     releaseInfo: VersionInfo
// };